module.exports = __webpack_public_path__ + "static/media/luciana-gervasio.51ad1728.png";